const state = {
  listaItensGlossario: [],
  dialogEdicao: false,
  listaTiposDocumento: []
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/administracao/state.js